// @flow
import React from 'react';
import { connect } from 'react-redux';

import { SOCKET_HOST, DEFAULT_SOCKET_ROLE } from '../settings';
import * as selectors from '../reducers';
import * as actions from '../actions/socket';

type SocketConnectorPropTypes = {
  host: string,
  userId: string,
  token: string,
  openSocket: Function,
  closeSocket: Function,
  defaultRooms: Array<string>
};

class SocketConnector extends React.Component<SocketConnectorPropTypes> {
  componentWillMount() {
    const { host, userId, token, openSocket, defaultRooms } = this.props;
    openSocket(host, userId, token, defaultRooms);
  }

  componentWillUnmount() {
    const { host, userId, token, closeSocket } = this.props;
    closeSocket(host, userId, token);
  }

  render = () => null;
}

export default connect(
  state => {
    const userId = selectors.getUserId(state);
    const profile = selectors.getProfileOfType(state, 'admin');
    return {
      userId,
      token: selectors.getToken(state),
      defaultRooms: [ `school:${ typeof profile !== 'undefined' ? profile.school: '' }`, `user:${ userId }` ],
      host: SOCKET_HOST
    };
  },
  dispatch => ({
    openSocket(host, userId, token, defaultRooms) {
      dispatch(actions.open(host, userId, token, DEFAULT_SOCKET_ROLE, defaultRooms));
    },
    closeSocket(host, userId, token) {
      dispatch(actions.close(host, userId, token));
    }
  })
)(SocketConnector);



// WEBPACK FOOTER //
// ./src/scripts/components/socketConnector.js